import '../stylesheets/profile-pic-upload.css';
import { useEffect, useState } from "react"
import { Dialog } from 'primereact/dialog';
import FileSelect from './file-select';
import { useDispatch, useSelector } from 'react-redux';
import { getWabaProfileData } from '../../../reducers/waba-profile/waba-prifile-actions';
import { Image } from 'primereact/image';
import { Text } from '../../../components/Text';
const ProfilePicUpload = () => {
    const { profilePic, loading } = useSelector(state => state.wabaProfile);
    const [visible, setVisible] = useState(false);
    const dispatch = useDispatch();
    const handleButtonClick = () => {
        setVisible(true)
    }
    const handleClose = () => {
        setVisible(false);
    }
    useEffect(() => {
        dispatch(getWabaProfileData());
    }, [])

    const dialogHeader = () =>{
        return profilePic ? <Text type={'heading'}>Change Logo</Text> : <Text type={'heading'}>Upload Logo</Text>
    }

    return <div >
        <Dialog header={dialogHeader()} visible={visible} style={{ width: '40vw' }} onHide={handleClose}>
            <FileSelect onCancel={handleClose} />
        </Dialog>
        {
            profilePic ?<div className='relative'>
                 <div className='profile-pic-upload'>
                <Image src={profilePic} alt='profile_pic' width="100%" height='100%' className='img-prf' />
                
            </div>
            <div className='profile-pic-action'>
                    
                     <button onClick={handleButtonClick}>
                        <i className='pi pi-pencil' style={{fontSize:"0.8rem"}} />
                    </button>

                </div>
            </div> :
                <button type="button" className="profile-pic-upload profile-pic-upload-btn" onClick={handleButtonClick} > <div className='btn-icon px-2 py-1'>{loading? <i className='pi pi-spin' /> :<span>+</span>}</div> </button>

        }
    </div>
}

export default ProfilePicUpload;